export default [
  [`Российский размер`, `36`, `37`, `38`, `39`, `40`, `41`],
  [`Длина стельки, см`, `23,5`, `24`, `24,5`, `25`, `26`, `26,5`]
];
